module.exports = __webpack_public_path__ + "static/media/CardCompPLO5Blue.1d1132d0.png";